import { Site, Domain } from '@chegg-wt/core/types/site'
import { GatedStyleRule } from '@chegg-wt/core/types/styles'
import { AppEnvs, NodeEnvs } from './constants/global'

export const Config = {
  /**
   * appEnv:
   *
   * Playground and production set this environment variable, if we just leave it empty
   *  locally we can then assume we're running the APP in `development` mode as opposed to
   *  `playground` or `production` mode. This is needed because of some of the differences
   *  between our local setups and those used in production/playground.
   */
  appEnv: process.env.APP_ENV || AppEnvs.DEVELOPMENT,
  nodeEnv: process.env.NODE_ENV || NodeEnvs.DEVELOPMENT,
  ucfVer: process.env.UCF_VER || '0.0.0',
  adsProdUrl: 'https://atc-edge.studybreakmedia.com',
  adsStagingUrl: 'https://adtech.test.cheggnet.com',
  archieLeague: process.env.ARCHIE_LEAGUE_ENV || 'production',
  autociteKey: process.env.AUTO_CITE_KEY || 'anuZaem3ChaichuGhoh8gaiNeequee',
  apiKey: process.env.FOOTNOTES_API_KEY || '9b188a28c4fd8fc3e667e153033f8470',
  apiUrl: process.env.FOOTNOTES_API_URL || 'https://csl.wtai.ezbib.com/2.1/rest',
  autociteUrl: process.env.AUTOCITE_URL || 'https://autocite.writing.test.cheggnet.com',
  autociteFeedbackUrl:
    process.env.AUTOCITE_FEEDBACK_URL || 'https://data.nonprod.studybreakmedia.com:8877/',
  advertiseWithUsUrl: 'https://collegemarketing.chegg.com',
  baseUrl: process.env.BASE_URL || 'https://playground.easybib.com',
  bffUrl: process.env.BFF_URL || 'https://bff.writing.test.cheggnet.com/graphql',
  oneGraphUrl:
    process.env.ONE_GRAPH_URL || 'https://gateway.test.cheggnet.com/one-graph/graphql',
  googleAPIKey: process.env.GOOGLE_API_KEY || 'AIzaSyBR7lwc8aQs1No8RX-Wf_ixQt9T2mXJILY',
  googleClientId:
    process.env.GOOGLE_CLIENT_ID ||
    '1021946012889-9rc9iq615qss0a4obods0apljebubl8q.apps.googleusercontent.com',
  writingUrl: process.env.WFE_URL || 'https://writing-playground.citationmachine.net',
  trialTermsAndConditionsUrl: process.env.TRIAL_TERMS_AND_CONDITIONS_URL || '',
  grammarAndPlagiarismUrl: process.env.GRAMMAR_AND_PLAGIARISM_URL || '',
  expertCheckUrl: process.env.EXPERT_CHECK_URL || '',
  styleUrl: process.env.STYLE_URL || 'https://playground.citationmachine.net/api/styles',
  tokenUrl:
    process.env.TOKEN_URL ||
    'https://playground.citationmachine.net/api/auth/token?client=cfe&ucf=true',
  migrateUrl: process.env.MIGRATE_URL || '',
  privacyComplianceUrl: `https://gdpr.studybreakmedia.com/consent/${process.env.PRIVACY_COMPLIANCE_HASH}.js`,
  oneTrustComplianceUrl:
    process.env.ONE_TRUST_COMPLIANCE_URL ||
    `https://cdn.cookielaw.org/scripttemplates/otSDKStub.js`,
  oneTrustCcpaCategoryIds: process.env.ONE_TRUST_CCPA_CATEGORY_IDS || 'trg,SPD_BG',
  oneTrustComplianceUrlHash:
    process.env.ONE_TRUST_COMPLIANCE_HASH || `927b7537-e17c-480f-9745-1c6299480ec2`,
  authUrl: process.env.AUTH_URL || 'https://playground.citationmachine.net/api/auth',
  guidesUrl: process.env.GUIDES_URL || 'https://playground.easybib.com/guides',
  currentStyle: process.env.CURRENT_STYLE || '',
  currentStyleName: process.env.CURRENT_STYLE_NAME || '',
  dataMigrationInProgress: process.env.DATA_MIGRATION_IN_PROGRESS,
  gatedStyleRules: (process.env.GATED_STYLE_RULES || []) as GatedStyleRule[],
  enableFolders: process.env.ENABLE_FOLDERS === 'true',
  enableGrammar: process.env.ENABLE_GRAMMAR === 'true',
  releaseVersion: process.env.RELEASE_VERSION || null,
  gtmID: process.env.GTM_ID || '',
  gtmAuth: process.env.GTM_AUTH || '',
  gtmPreview: process.env.GTM_PREVIEW || '',
  lpAssetsCdn: process.env.LP_ASSETS_CDN || 'https://c-test.cheggcdn.com/assets/',
  cheggEnvUrl: process.env.CHEGG_ENV_URL,
  optimizelySdkKey: process.env.OPTIMIZELY_SDK_KEY,
  optimizelyProjectId: process.env.OPTIMIZELY_PROJECT_ID || '17022043465',
  cookieDomain: process.env.COOKIE_DOMAIN as Domain,
  adobeDtmUrl: process.env.ADOBE_DTM_URL,
  hasPremiumCitations: process.env.HAS_PREMIUM_CITATIONS === 'true',
  hasCitationsDashboard: process.env.HAS_CITATIONS_DASHBOARD === 'true',
  tokenSiteCode: process.env.TOKEN_SITE_CODE as Site,
  assetPrefix: process.env.ASSET_PREFIX || '',
  basePath: process.env.BASE_PATH || '',
  bibliographyCitationCountThreshold:
    parseInt(process.env.BIBLIOGRAPHY_CITATION_COUNT_THRESHOLD, 10) || undefined,
  bibliographyCitationCountWarningThreshold:
    parseInt(process.env.BIBLIOGRAPHY_CITATION_COUNT_WARNING_THRESHOLD, 10) || undefined,
  siteName: process.env.SITE_NAME,
  appName: process.env.APP_NAME,
  inlineUploadWidget: process.env.INLINE_UPLOAD_WIDGET === 'true',
  bibliographyExpirationInDays:
    parseInt(process.env.BIBLIOGRAPHY_EXPIRATION_IN_DAYS, 10) || undefined,
  sbmRioEndpoint:
    process.env.SBM_RIO_ENDPOINT ||
    'https://analytics.dev.cheggnet.com/rio-service-wt/rest/rio-events/batch',
  dipApiKey:
    process.env.DIP_API_KEY ||
    'U3lCd0txRkdHRUFBVjYxdEJ2OGpWMVJlZFFFY0dTanc6eHVWcDdHSEU5bkxlRE81Uw==',
  gateInTextCitations: process.env.GATE_IN_TEXT_CITATIONS === 'true',
  disableOptimizelyLogger: process.env.DISABLE_OPTIMIZELY_LOGGER === 'true',
  disableGTMLogger: process.env.DISABLE_GTM_LOGGER === 'true',
  disableReduxLogger: process.env.DISABLE_REDUX_LOGGER === 'true',
  disableAllMiddlewareLoggers: process.env.DISABLE_ALL_MIDDLEWARE_LOGGERS === 'true',
  citationsHomeIsSubPage: process.env.CITATIONS_HOME_IS_SUB_PAGE === 'true',
  viewPageExitIntent: process.env.VIEW_PAGE_EXIT_INTENT || null,
  showUnlockAccountGateModal: process.env.UNLOCK_ACCOUNT_GATE_MODAL === 'true',
  showSourcePageAccountCreationBanner: process.env.SHOW_SOURCE_ACCOUNT_BANNER === 'true',
  worldcatUrl: process.env.WORLDCAT_URL || 'http://worldcat.org/oclc',
  pricingTestFeatureName: process.env.PRICING_TEST_FEATURE_NAME || 'eb-price-test',
  semPricingTestFeatureName:
    process.env.SEM_PRICING_TEST_FEATURE_NAME || 'sem-eb-price-test',
  contentfulSpaceId: process.env.CONTENTFUL_SPACE_ID || 'tyud7ewy436h',
  contentfulAccessToken: process.env.CONTENTFUL_ACCESS_TOKEN || '',
  contentfulEnv: process.env.CONTENTFUL_ENV || 'dev',
  logoAlt: process.env.LOGO_ALT || '',
  logoWidth: parseInt(process.env.LOGO_WIDTH, 10) || undefined,
  checkoutFeatureListEntryId: process.env.CHECKOUT_FEATURE_LIST_ENTRY_ID || '',
  shouldOpenInNewTab: process.env.SHOULD_OPEN_IN_NEW_TAB === 'true',
  enableAdsInOptimizely: process.env.ENABLE_ADS_IN_OPTIMIZELY === 'true',
  headerDataSource:
    process.env.HEADER_DATA_SOURCE || 'https://gateway.chegg.com/me-web-bff/graphql',
  gamUrl: process.env.GAM_URL || '',
  dfpSiteId: process.env.DFP_SITE_ID || '',
  loginAdUnit: process.env.LOGIN_AD_UNIT || '',
  useCheggMeHeaders: process.env.USE_CHEGG_ME_HEADERS === 'true' || false,
  styleNotInSourceSearchPageUrl: process.env.STYLE_NOT_IN_SOURCE_SEARCH_PAGE_URL || false,
  editCitationGate: process.env.EDIT_CITATION_GATE === 'true' || false,
  premiumAccountCopy: process.env.PREMIUM_ACCOUNT_COPY || 'Premium',
  skipMigrationStatusCheck: process.env.SKIP_MIGRATION_STATUS_CHECK,
  enableRedirectionToCWC: process.env.ENABLE_REDIRECTION_TO_CWC || false,
  showInterstitialAd: process.env.SHOW_INTERSTITIAL_AD || false,
  paperCheckWordCountLimit: process.env.PAPER_CHECK_WORD_COUNT_LIMIT || '10,000',
  useAuthModalFlow: process.env.USE_AUTH_MODAL_FLOW === 'true' || false,
  enableParaphraser: process.env.ENABLE_PARAPHRASER === 'true' || false,
  enableStyleGate: process.env.ENABLE_STYLE_GATE === 'true' || false,
  ctfmUpgradeCTAText: process.env.CTFM_UPGRADE_CTA_TEXT,
  enableSearchWidgetExp: process.env.ENABLE_SEARCH_WIDGET_EXPERIENCE === 'true' || false,
  flankerSitesBannerCTAUpdate: process.env.FLANKER_SITES_BANNER_CTA_UPDATE,
  adUnlockModalExperience: process.env.AD_UNLOCK_MODAL_EXPERIENCE || false,
  wtaiUrl: process.env.WTAI_BASE_URL,
  cheggEnv: process.env.CHEGG_ENV || 'test',
  authgateUrl: process.env.AUTH_GATE_URL || '',
}
